

















import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
@Component({
  components: {}
})
export default class MailDetailBody extends ComponentVue {
  @Prop({
    type: String,
    required: true
  })
  body!: string

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  get cssCustomProperty(): any {
    return {
      '--height': this.height + 'px'
    }
  }
}
